import AdminApi from '../services/api';
import swal from 'sweetalert2';

/* init */

const AdminApiService = new AdminApi()

export default{

    props: ['show', 'notes'],

    data() {
        return {
            title: 'Napomene kurira',
            isLoading: false,
            vacationsNotes: [],
            hasError: ''
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val === true){
                this.vacationsNotes = this.notes.sort((a,b) => this.compareByTime(a.date,b.date));
            }
        },
    },

    methods: {
        compareByTime(a, b) {
            if (a < b)
                return -1;
            if (a > b)
                return 1;
            return 0;
        },
        close() {
            this.$topnavbar.$emit('closeShowCommentSchedule')
        },
        deleteComment: deleteComment,
        getVacationsRequested: getVacationsRequested,
        formatDate: formatDate,
        reset: reset,
    }
}

function formatDate(date) {
    return this.$moment(new Date(date )).format('DD-MM-YYYY')
}

function deleteComment(comment){
    let _self = this;
    AdminApiService.deleteVacation(comment.id)
        .then((response) => {
            _self.getVacationsRequested();
        })
        .catch((error) => {
            swal('Greška', error.data.message, 'error')
        })
}

function getVacationsRequested(){
    let _self = this;
    AdminApiService.getRequestedVacations()
        .then((response) => {
            _self.vacationsNotes = response.data.filter(e => (e.status === 'REQUESTED' && e.notes != null && e.notes.length !== 0));
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function reset() {
    this.vacationsNotes = [];
}



// WEBPACK FOOTER //
// ./src/modals/ShowCommentSchedule.js